import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-releases",
  templateUrl: "./releases.component.html",
  styleUrls: ["./releases.component.css"],
})
export class ReleasesComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
